// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y4bI","right":"styles_right__20VO-"};